import React, { useState, useEffect } from "react";
import Routes from "./Routes/index";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-datepicker/dist/react-datepicker.css";

//import Custom Style scss
import "./assets/scss/themes.scss";
import AddStockForm from "./pages/StockForm/AddStock";
import { requestNotificationPermission, onMessageListener } from "./firebase";
function App() {
  const [message, setMessage] = useState(null);

  useEffect(() => {
    requestNotificationPermission();

    onMessageListener()
      .then((payload) => {
        setMessage(payload);
      })
      .catch((err) => console.log("failed: ", err));
  }, []);
  return (
    <React.Fragment>
      <link
        rel="stylesheet"
        href="https://unpkg.com/leaflet@1.9.4/dist/leaflet.css"
        integrity="sha256-oM2A46LAaJpntkAkKHNExSTacWklwHO9zmNF5GzI5lo="
        crossorigin=""
      />

      <Routes />
    </React.Fragment>
  );
}

export default App;
